import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1161px;

  > h1 {
    text-align: center;
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 32px;

  @media (min-width: 640px) {
    justify-content: start;
  }
`;

export const Filter = styled.form`
  border-radius: 10px;
  border: 1px solid #9d9d9d;
  padding: 32px 12px;
  margin-bottom: 32px;
  display: grid;
  gap: 32px;
  width: 100%;
  max-width: 1091px;
  grid-template-columns: 1fr;
  grid-template-areas: "nome" "cpf" "buttoms";
  > :nth-child(1) {
    grid-area: nome;
  }
  > :nth-child(2) {
    grid-area: cpf;
  }
  > :nth-child(3) {
    grid-area: buttoms;
    display: flex;
    justify-content: center;
    gap: 16px;
  }

  @media (min-width: 640px) {
    padding: 32px;
    gap: 16px;
    grid-template-columns: 1fr 0.5fr 0.2fr;
    grid-template-areas: "nome cpf buttoms";
  }
`;

export const Table = styled.div`
  margin-bottom: 32px;

  div + div {
    margin-top: 16px;
  }
`;

export const TableItem = styled.div`
  border-radius: 10px;
  background: #e8e8e8;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 0.1fr;
  grid-template-areas: "nome eye" "cpf cpf";

  > p {
    color: #2d2d2d;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.36px;
    text-transform: uppercase;

    span {
      font-weight: 400;
    }
  }

  > :nth-child(1) {
    grid-area: nome;
  }

  > :nth-child(2) {
    grid-area: cpf;
  }

  > :nth-child(3) {
    grid-area: eye;
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr 0.1fr;
    align-items: center;
    grid-template-areas: "nome cpf eye";
  }
`;
